import { Injectable } from '@angular/core';



@Injectable()
export class FormCCService {

    private pendingApprovalFormCCData = null;
    private approvedFormccData = null;
    private isAdminId = null;
    private isAdminRejectId = null;
    private orgInfoData = null;
    private controlReportData = null;

    constructor() { }

    setpendingApprovalFormCCData(pendingApprovalFormCCData: any[]) {
        // console.log('Service: pendingApprovalFormCC')
        this.pendingApprovalFormCCData = pendingApprovalFormCCData;
        // console.log(this.pendingApprovalFormCCData)
        // this.transactionDetailsChanged.next(this.transactionDetails.slice());
    }

    getpendingApprovalFormCCData() {
        return this.pendingApprovalFormCCData;
    }

    setApprovedFormCCData(formccId) {
        this.approvedFormccData = formccId;
    }

    getApprovedFormCCData() {
        return this.approvedFormccData;
    }

    setIsAdminReadOnly(formccId) {
        this.isAdminId = formccId;
    }

    getIsAdminReadOnly() {
        return this.isAdminId;
    }

    setIsAdminReject(data) {
        this.isAdminRejectId = data === null ? 1 : null;
    }

    getIsAdminReject() {
        return this.isAdminRejectId;
    }


    setOrgInfoDetails(orgInfoData) {
        this.orgInfoData = orgInfoData;
    }

    getOrgInfoDetails() {
        return this.orgInfoData;
    }

    setControlReportData(controlReportData) {
        this.controlReportData = controlReportData;
    }

    getControlReportData() {
        return this.controlReportData;
    }
}